@let isCtaCentered = displayCtaOnly && stepsTotal === 1;

<div class="left-side">
  @if (!displayCtaOnly && !dialogHelpArticle) {
    <rt-button variant="outline-ghost" (click)="cancel.emit()">
      @if (closeIcon) {
        <rt-icon [name]="closeIcon"></rt-icon>
      }
      <span>{{ closeText }}</span>
    </rt-button>
  }

  @if (dialogHelpArticle) {
    <a rt-button variant="outline-ghost" [href]="dialogHelpArticle" target="_blank">
      <rt-icon name="open-in-new"></rt-icon>
      <span>{{ learnMoreText }}</span>
    </a>
  }
</div>

<div class="middle">
  @if (!displayCtaOnly) {
    <div class="step-counter">{{ currentStep }} {{ ofText }} {{ stepsTotal }}</div>
  }
  @if (isCtaCentered) {
    <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
  }
</div>

<div class="right-side">
  @if (!isCtaCentered) {
    <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
  }
</div>

<ng-template #ctaButton>
  <rt-button class="main-action" variant="tertiary" (click)="start.emit()">
    <span>{{ ctaText }}</span>
    @if (ctaIcon) {
      <rt-icon [name]="ctaIcon"></rt-icon>
    }
  </rt-button>
</ng-template>
